"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateCouponsServiceServer = exports.PrivateCouponsServiceDispatcher = exports.PrivateCouponsServiceClient = void 0;
var UserCouponsResponse_1 = require("./UserCouponsResponse");
var CouponTemplateID_1 = require("./CouponTemplateID");
var CouponTemplate_1 = require("./CouponTemplate");
var MassCouponData_1 = require("./MassCouponData");
var services_shared_1 = require("@playq/services-shared");
var DuplicateMassCouponCode_1 = require("./DuplicateMassCouponCode");
var UnknownItemsFailure_1 = require("./UnknownItemsFailure");
var CouponIdsListResponse_1 = require("./CouponIdsListResponse");
var CouponTemplatesListResponse_1 = require("./CouponTemplatesListResponse");
var MassCoupon_1 = require("./MassCoupon");
var CouponTemplateData_1 = require("./CouponTemplateData");
var CouponID_1 = require("./CouponID");
var CouponsListResponse_1 = require("./CouponsListResponse");
var InRegisterMassCoupon = (function () {
    function InRegisterMassCoupon(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.coupon = MassCouponData_1.MassCouponDataStruct.create(data.coupon);
        this.id = typeof data.id !== 'undefined' ? new CouponID_1.CouponID(data.id) : undefined;
    }
    Object.defineProperty(InRegisterMassCoupon.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterMassCoupon.prototype, "coupon", {
        get: function () {
            return this._coupon;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field coupon is not optional');
            }
            this._coupon = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterMassCoupon.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._id = undefined;
                return;
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InRegisterMassCoupon.prototype.serialize = function () {
        var _a;
        return {
            app: this.app.serialize(),
            coupon: (_a = {}, _a[this.coupon.getFullClassName()] = this.coupon.serialize(), _a),
            id: typeof this.id !== 'undefined' ? this.id.serialize() : undefined
        };
    };
    return InRegisterMassCoupon;
}());
var OutRegisterMassCouponHelpers = (function () {
    function OutRegisterMassCouponHelpers() {
    }
    OutRegisterMassCouponHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponID_1.CouponID || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure || o instanceof DuplicateMassCouponCode_1.DuplicateMassCouponCode;
    };
    OutRegisterMassCouponHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutRegisterMassCouponHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponID': return new CouponID_1.CouponID(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            case 'DuplicateMassCouponCode': return new DuplicateMassCouponCode_1.DuplicateMassCouponCode(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutRegisterMassCoupon');
        }
    };
    return OutRegisterMassCouponHelpers;
}());
var InUpdateMassCoupon = (function () {
    function InUpdateMassCoupon(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.coupon = new MassCoupon_1.MassCoupon(data.coupon);
    }
    Object.defineProperty(InUpdateMassCoupon.prototype, "coupon", {
        get: function () {
            return this._coupon;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field coupon is not optional');
            }
            this._coupon = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateMassCoupon.prototype.serialize = function () {
        return {
            coupon: this.coupon.serialize()
        };
    };
    return InUpdateMassCoupon;
}());
var OutUpdateMassCouponHelpers = (function () {
    function OutUpdateMassCouponHelpers() {
    }
    OutUpdateMassCouponHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof services_shared_1.CommonSuccess || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure || o instanceof DuplicateMassCouponCode_1.DuplicateMassCouponCode;
    };
    OutUpdateMassCouponHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutUpdateMassCouponHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CommonSuccess': return new services_shared_1.CommonSuccess(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            case 'DuplicateMassCouponCode': return new DuplicateMassCouponCode_1.DuplicateMassCouponCode(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutUpdateMassCoupon');
        }
    };
    return OutUpdateMassCouponHelpers;
}());
var InUnregisterMassCoupon = (function () {
    function InUnregisterMassCoupon(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new CouponID_1.CouponID(data.id);
    }
    Object.defineProperty(InUnregisterMassCoupon.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InUnregisterMassCoupon.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InUnregisterMassCoupon;
}());
var OutUnregisterMassCouponHelpers = (function () {
    function OutUnregisterMassCouponHelpers() {
    }
    OutUnregisterMassCouponHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof services_shared_1.CommonSuccess || o instanceof services_shared_1.CommonFailure;
    };
    OutUnregisterMassCouponHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutUnregisterMassCouponHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CommonSuccess': return new services_shared_1.CommonSuccess(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutUnregisterMassCoupon');
        }
    };
    return OutUnregisterMassCouponHelpers;
}());
var InRegisterCouponTemplate = (function () {
    function InRegisterCouponTemplate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.coupon = CouponTemplateData_1.CouponTemplateDataStruct.create(data.coupon);
        this.id = typeof data.id !== 'undefined' ? new CouponTemplateID_1.CouponTemplateID(data.id) : undefined;
    }
    Object.defineProperty(InRegisterCouponTemplate.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterCouponTemplate.prototype, "coupon", {
        get: function () {
            return this._coupon;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field coupon is not optional');
            }
            this._coupon = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterCouponTemplate.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._id = undefined;
                return;
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InRegisterCouponTemplate.prototype.serialize = function () {
        var _a;
        return {
            app: this.app.serialize(),
            coupon: (_a = {}, _a[this.coupon.getFullClassName()] = this.coupon.serialize(), _a),
            id: typeof this.id !== 'undefined' ? this.id.serialize() : undefined
        };
    };
    return InRegisterCouponTemplate;
}());
var OutRegisterCouponTemplateHelpers = (function () {
    function OutRegisterCouponTemplateHelpers() {
    }
    OutRegisterCouponTemplateHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponTemplateID_1.CouponTemplateID || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure;
    };
    OutRegisterCouponTemplateHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutRegisterCouponTemplateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponTemplateID': return new CouponTemplateID_1.CouponTemplateID(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutRegisterCouponTemplate');
        }
    };
    return OutRegisterCouponTemplateHelpers;
}());
var InUpdateCouponTemplate = (function () {
    function InUpdateCouponTemplate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.coupon = new CouponTemplate_1.CouponTemplate(data.coupon);
    }
    Object.defineProperty(InUpdateCouponTemplate.prototype, "coupon", {
        get: function () {
            return this._coupon;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field coupon is not optional');
            }
            this._coupon = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateCouponTemplate.prototype.serialize = function () {
        return {
            coupon: this.coupon.serialize()
        };
    };
    return InUpdateCouponTemplate;
}());
var OutUpdateCouponTemplateHelpers = (function () {
    function OutUpdateCouponTemplateHelpers() {
    }
    OutUpdateCouponTemplateHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof services_shared_1.CommonSuccess || o instanceof services_shared_1.CommonFailure || o instanceof UnknownItemsFailure_1.UnknownItemsFailure;
    };
    OutUpdateCouponTemplateHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutUpdateCouponTemplateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CommonSuccess': return new services_shared_1.CommonSuccess(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            case 'UnknownItemsFailure': return new UnknownItemsFailure_1.UnknownItemsFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutUpdateCouponTemplate');
        }
    };
    return OutUpdateCouponTemplateHelpers;
}());
var InUnregisterCouponTemplate = (function () {
    function InUnregisterCouponTemplate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new CouponTemplateID_1.CouponTemplateID(data.id);
    }
    Object.defineProperty(InUnregisterCouponTemplate.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InUnregisterCouponTemplate.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InUnregisterCouponTemplate;
}());
var OutUnregisterCouponTemplateHelpers = (function () {
    function OutUnregisterCouponTemplateHelpers() {
    }
    OutUnregisterCouponTemplateHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof services_shared_1.CommonSuccess || o instanceof services_shared_1.CommonFailure;
    };
    OutUnregisterCouponTemplateHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutUnregisterCouponTemplateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CommonSuccess': return new services_shared_1.CommonSuccess(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutUnregisterCouponTemplate');
        }
    };
    return OutUnregisterCouponTemplateHelpers;
}());
var InGetMassCoupons = (function () {
    function InGetMassCoupons(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.iterator = typeof data.iterator !== 'undefined' ? new services_shared_1.OffsetLimit(data.iterator) : undefined;
    }
    Object.defineProperty(InGetMassCoupons.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetMassCoupons.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._iterator = undefined;
                return;
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetMassCoupons.prototype.serialize = function () {
        return {
            app: this.app.serialize(),
            iterator: typeof this.iterator !== 'undefined' ? this.iterator.serialize() : undefined
        };
    };
    return InGetMassCoupons;
}());
var OutGetMassCouponsHelpers = (function () {
    function OutGetMassCouponsHelpers() {
    }
    OutGetMassCouponsHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponsListResponse_1.CouponsListResponse || o instanceof services_shared_1.CommonFailure;
    };
    OutGetMassCouponsHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetMassCouponsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponsListResponse': return new CouponsListResponse_1.CouponsListResponse(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetMassCoupons');
        }
    };
    return OutGetMassCouponsHelpers;
}());
var InGetCouponTemplates = (function () {
    function InGetCouponTemplates(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.iterator = typeof data.iterator !== 'undefined' ? new services_shared_1.OffsetLimit(data.iterator) : undefined;
    }
    Object.defineProperty(InGetCouponTemplates.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetCouponTemplates.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._iterator = undefined;
                return;
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetCouponTemplates.prototype.serialize = function () {
        return {
            app: this.app.serialize(),
            iterator: typeof this.iterator !== 'undefined' ? this.iterator.serialize() : undefined
        };
    };
    return InGetCouponTemplates;
}());
var OutGetCouponTemplatesHelpers = (function () {
    function OutGetCouponTemplatesHelpers() {
    }
    OutGetCouponTemplatesHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponTemplatesListResponse_1.CouponTemplatesListResponse || o instanceof services_shared_1.CommonFailure;
    };
    OutGetCouponTemplatesHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetCouponTemplatesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponTemplatesListResponse': return new CouponTemplatesListResponse_1.CouponTemplatesListResponse(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetCouponTemplates');
        }
    };
    return OutGetCouponTemplatesHelpers;
}());
var InGetIssuedCoupons = (function () {
    function InGetIssuedCoupons(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.templateId = new CouponTemplateID_1.CouponTemplateID(data.templateId);
        this.iterator = typeof data.iterator !== 'undefined' ? new services_shared_1.OffsetLimit(data.iterator) : undefined;
    }
    Object.defineProperty(InGetIssuedCoupons.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetIssuedCoupons.prototype, "templateId", {
        get: function () {
            return this._templateId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field templateId is not optional');
            }
            this._templateId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetIssuedCoupons.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._iterator = undefined;
                return;
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetIssuedCoupons.prototype.serialize = function () {
        return {
            app: this.app.serialize(),
            templateId: this.templateId.serialize(),
            iterator: typeof this.iterator !== 'undefined' ? this.iterator.serialize() : undefined
        };
    };
    return InGetIssuedCoupons;
}());
var OutGetIssuedCouponsHelpers = (function () {
    function OutGetIssuedCouponsHelpers() {
    }
    OutGetIssuedCouponsHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponsListResponse_1.CouponsListResponse || o instanceof services_shared_1.CommonFailure;
    };
    OutGetIssuedCouponsHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetIssuedCouponsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponsListResponse': return new CouponsListResponse_1.CouponsListResponse(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetIssuedCoupons');
        }
    };
    return OutGetIssuedCouponsHelpers;
}());
var InGetUserCoupons = (function () {
    function InGetUserCoupons(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.userId = data.userId;
    }
    Object.defineProperty(InGetUserCoupons.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetUserCoupons.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field userId expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field userId expects guid format, got ' + value);
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetUserCoupons.prototype.serialize = function () {
        return {
            app: this.app.serialize(),
            userId: this.userId
        };
    };
    return InGetUserCoupons;
}());
var OutGetUserCouponsHelpers = (function () {
    function OutGetUserCouponsHelpers() {
    }
    OutGetUserCouponsHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof UserCouponsResponse_1.UserCouponsResponse || o instanceof services_shared_1.CommonFailure;
    };
    OutGetUserCouponsHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetUserCouponsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'UserCouponsResponse': return new UserCouponsResponse_1.UserCouponsResponse(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetUserCoupons');
        }
    };
    return OutGetUserCouponsHelpers;
}());
var InIssueTargeted = (function () {
    function InIssueTargeted(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.templateId = new CouponTemplateID_1.CouponTemplateID(data.templateId);
        this.recipients = data.recipients.slice();
        this.message = typeof data.message !== 'undefined' ? data.message : undefined;
        this.id = typeof data.id !== 'undefined' ? new CouponID_1.CouponID(data.id) : undefined;
    }
    Object.defineProperty(InIssueTargeted.prototype, "templateId", {
        get: function () {
            return this._templateId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field templateId is not optional');
            }
            this._templateId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InIssueTargeted.prototype, "recipients", {
        get: function () {
            return this._recipients;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field recipients is not optional');
            }
            this._recipients = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InIssueTargeted.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._message = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field message expects type string, got ' + value);
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InIssueTargeted.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._id = undefined;
                return;
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InIssueTargeted.prototype.serialize = function () {
        return {
            templateId: this.templateId.serialize(),
            recipients: this.recipients.slice(),
            message: typeof this.message !== 'undefined' ? this.message : undefined,
            id: typeof this.id !== 'undefined' ? this.id.serialize() : undefined
        };
    };
    return InIssueTargeted;
}());
var OutIssueTargetedHelpers = (function () {
    function OutIssueTargetedHelpers() {
    }
    OutIssueTargetedHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponID_1.CouponID || o instanceof services_shared_1.CommonFailure;
    };
    OutIssueTargetedHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutIssueTargetedHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponID': return new CouponID_1.CouponID(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutIssueTargeted');
        }
    };
    return OutIssueTargetedHelpers;
}());
var InGetRegisteredCouponsIds = (function () {
    function InGetRegisteredCouponsIds(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
    }
    Object.defineProperty(InGetRegisteredCouponsIds.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetRegisteredCouponsIds.prototype.serialize = function () {
        return {
            app: this.app.serialize()
        };
    };
    return InGetRegisteredCouponsIds;
}());
var OutGetRegisteredCouponsIdsHelpers = (function () {
    function OutGetRegisteredCouponsIdsHelpers() {
    }
    OutGetRegisteredCouponsIdsHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof CouponIdsListResponse_1.CouponIdsListResponse || o instanceof services_shared_1.CommonFailure;
    };
    OutGetRegisteredCouponsIdsHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    OutGetRegisteredCouponsIdsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'CouponIdsListResponse': return new CouponIdsListResponse_1.CouponIdsListResponse(content);
            case 'CommonFailure': return new services_shared_1.CommonFailure(content);
            default:
                throw new Error('Unknown type id ' + id + ' for OutGetRegisteredCouponsIds');
        }
    };
    return OutGetRegisteredCouponsIdsHelpers;
}());
var PrivateCouponsServiceClient = (function () {
    function PrivateCouponsServiceClient(transport) {
        this._transport = transport;
    }
    PrivateCouponsServiceClient.prototype.getPackageName = function () { return PrivateCouponsServiceClient.PackageName; };
    PrivateCouponsServiceClient.prototype.getClassName = function () { return PrivateCouponsServiceClient.ClassName; };
    PrivateCouponsServiceClient.prototype.getFullClassName = function () { return PrivateCouponsServiceClient.FullClassName; };
    PrivateCouponsServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.registerMassCoupon = function (app, coupon, id) {
        var _this = this;
        var __data = new InRegisterMassCoupon();
        __data.app = app;
        __data.coupon = coupon;
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'registerMassCoupon', __data)
                .then(function (data) {
                try {
                    resolve(OutRegisterMassCouponHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.updateMassCoupon = function (coupon) {
        var _this = this;
        var __data = new InUpdateMassCoupon();
        __data.coupon = coupon;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'updateMassCoupon', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateMassCouponHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.unregisterMassCoupon = function (id) {
        var _this = this;
        var __data = new InUnregisterMassCoupon();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'unregisterMassCoupon', __data)
                .then(function (data) {
                try {
                    resolve(OutUnregisterMassCouponHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.registerCouponTemplate = function (app, coupon, id) {
        var _this = this;
        var __data = new InRegisterCouponTemplate();
        __data.app = app;
        __data.coupon = coupon;
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'registerCouponTemplate', __data)
                .then(function (data) {
                try {
                    resolve(OutRegisterCouponTemplateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.updateCouponTemplate = function (coupon) {
        var _this = this;
        var __data = new InUpdateCouponTemplate();
        __data.coupon = coupon;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'updateCouponTemplate', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateCouponTemplateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.unregisterCouponTemplate = function (id) {
        var _this = this;
        var __data = new InUnregisterCouponTemplate();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'unregisterCouponTemplate', __data)
                .then(function (data) {
                try {
                    resolve(OutUnregisterCouponTemplateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.getMassCoupons = function (app, iterator) {
        var _this = this;
        var __data = new InGetMassCoupons();
        __data.app = app;
        __data.iterator = iterator;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'getMassCoupons', __data)
                .then(function (data) {
                try {
                    resolve(OutGetMassCouponsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.getCouponTemplates = function (app, iterator) {
        var _this = this;
        var __data = new InGetCouponTemplates();
        __data.app = app;
        __data.iterator = iterator;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'getCouponTemplates', __data)
                .then(function (data) {
                try {
                    resolve(OutGetCouponTemplatesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.getIssuedCoupons = function (app, templateId, iterator) {
        var _this = this;
        var __data = new InGetIssuedCoupons();
        __data.app = app;
        __data.templateId = templateId;
        __data.iterator = iterator;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'getIssuedCoupons', __data)
                .then(function (data) {
                try {
                    resolve(OutGetIssuedCouponsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.getUserCoupons = function (app, userId) {
        var _this = this;
        var __data = new InGetUserCoupons();
        __data.app = app;
        __data.userId = userId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'getUserCoupons', __data)
                .then(function (data) {
                try {
                    resolve(OutGetUserCouponsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.issueTargeted = function (templateId, recipients, message, id) {
        var _this = this;
        var __data = new InIssueTargeted();
        __data.templateId = templateId;
        __data.recipients = recipients;
        __data.message = message;
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'issueTargeted', __data)
                .then(function (data) {
                try {
                    resolve(OutIssueTargetedHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.prototype.getRegisteredCouponsIds = function (app) {
        var _this = this;
        var __data = new InGetRegisteredCouponsIds();
        __data.app = app;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateCouponsServiceClient.ClassName, 'getRegisteredCouponsIds', __data)
                .then(function (data) {
                try {
                    resolve(OutGetRegisteredCouponsIdsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateCouponsServiceClient.PackageName = 'net.playq.services.bookkeeper';
    PrivateCouponsServiceClient.ClassName = 'PrivateCouponsService';
    PrivateCouponsServiceClient.FullClassName = 'net.playq.services.bookkeeper.PrivateCouponsService';
    return PrivateCouponsServiceClient;
}());
exports.PrivateCouponsServiceClient = PrivateCouponsServiceClient;
var PrivateCouponsServiceDispatcher = (function () {
    function PrivateCouponsServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    PrivateCouponsServiceDispatcher.prototype.getSupportedService = function () {
        return 'PrivateCouponsService';
    };
    PrivateCouponsServiceDispatcher.prototype.getSupportedMethods = function () {
        return PrivateCouponsServiceDispatcher.methods;
    };
    PrivateCouponsServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "registerMassCoupon": {
                var obj_1 = new InRegisterMassCoupon(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.registerMassCoupon(context, obj_1.app, obj_1.coupon, obj_1.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRegisterMassCouponHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateMassCoupon": {
                var obj_2 = new InUpdateMassCoupon(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateMassCoupon(context, obj_2.coupon)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateMassCouponHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "unregisterMassCoupon": {
                var obj_3 = new InUnregisterMassCoupon(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.unregisterMassCoupon(context, obj_3.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUnregisterMassCouponHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "registerCouponTemplate": {
                var obj_4 = new InRegisterCouponTemplate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.registerCouponTemplate(context, obj_4.app, obj_4.coupon, obj_4.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRegisterCouponTemplateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateCouponTemplate": {
                var obj_5 = new InUpdateCouponTemplate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateCouponTemplate(context, obj_5.coupon)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateCouponTemplateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "unregisterCouponTemplate": {
                var obj_6 = new InUnregisterCouponTemplate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.unregisterCouponTemplate(context, obj_6.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUnregisterCouponTemplateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getMassCoupons": {
                var obj_7 = new InGetMassCoupons(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getMassCoupons(context, obj_7.app, obj_7.iterator)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetMassCouponsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getCouponTemplates": {
                var obj_8 = new InGetCouponTemplates(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getCouponTemplates(context, obj_8.app, obj_8.iterator)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetCouponTemplatesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getIssuedCoupons": {
                var obj_9 = new InGetIssuedCoupons(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getIssuedCoupons(context, obj_9.app, obj_9.templateId, obj_9.iterator)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetIssuedCouponsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getUserCoupons": {
                var obj_10 = new InGetUserCoupons(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getUserCoupons(context, obj_10.app, obj_10.userId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetUserCouponsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "issueTargeted": {
                var obj_11 = new InIssueTargeted(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.issueTargeted(context, obj_11.templateId, obj_11.recipients, obj_11.message, obj_11.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutIssueTargetedHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getRegisteredCouponsIds": {
                var obj_12 = new InGetRegisteredCouponsIds(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getRegisteredCouponsIds(context, obj_12.app)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetRegisteredCouponsIdsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by PrivateCouponsServiceDispatcher."));
        }
    };
    PrivateCouponsServiceDispatcher.methods = [
        "registerMassCoupon",
        "updateMassCoupon",
        "unregisterMassCoupon",
        "registerCouponTemplate",
        "updateCouponTemplate",
        "unregisterCouponTemplate",
        "getMassCoupons",
        "getCouponTemplates",
        "getIssuedCoupons",
        "getUserCoupons",
        "issueTargeted",
        "getRegisteredCouponsIds"
    ];
    return PrivateCouponsServiceDispatcher;
}());
exports.PrivateCouponsServiceDispatcher = PrivateCouponsServiceDispatcher;
var PrivateCouponsServiceServer = (function (_super) {
    __extends(PrivateCouponsServiceServer, _super);
    function PrivateCouponsServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    PrivateCouponsServiceServer.prototype.registerMassCoupon = function (context, app, coupon, id) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.updateMassCoupon = function (context, coupon) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.unregisterMassCoupon = function (context, id) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.registerCouponTemplate = function (context, app, coupon, id) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.updateCouponTemplate = function (context, coupon) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.unregisterCouponTemplate = function (context, id) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.getMassCoupons = function (context, app, iterator) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.getCouponTemplates = function (context, app, iterator) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.getIssuedCoupons = function (context, app, templateId, iterator) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.getUserCoupons = function (context, app, userId) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.issueTargeted = function (context, templateId, recipients, message, id) {
        throw new Error('Not implemented.');
    };
    PrivateCouponsServiceServer.prototype.getRegisteredCouponsIds = function (context, app) {
        throw new Error('Not implemented.');
    };
    return PrivateCouponsServiceServer;
}(PrivateCouponsServiceDispatcher));
exports.PrivateCouponsServiceServer = PrivateCouponsServiceServer;
//# sourceMappingURL=PrivateCouponsService.js.map